import axios from 'axios';
import { API } from '../../lib/api/api';

export const getFailedPosts = async (auth0UserId: string) => {
	try {
		return await axios.get(
			`${API}calendar/getFailedPosts?auth0UserId=${auth0UserId}`
		);
	} catch (e) {
		return {
			error: e,
			status: 'error',
			statusText: 'There was a problem retrieving your failed posts.',
			data: e
		};
	}
};
